<template>
  <div class="home">
  <SiteView></SiteView>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import SiteView from "./Site.vue"
export default {
  name: "HomePage",
  mixins: [uiView],
  components: {SiteView},
  props: {},
  watch: {},
  mounted() {
    // this.globalSnackbar = false;
    // const test = {
    //   title: "Home1",
    //   route: "home",
    //   icon: "mdi-hand",
    // };
    // this.settings.navigation.push(test);
  },
  data: () => ({

  }),
  methods: {

  },
};
</script>
<style lang="scss">
</style>
